import React from 'react';
import "./LoadingScreen.css";
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

function LoadingScreen({ percent }) {

  return (
    <div style={{ display: "flex", justifyContent: "center"}}>
        <div className="loadingScreen">
            <div className="progressBar">
                <CircularProgressbarWithChildren value={percent} counterClockwise={true} strokeWidth={3} className="circularProgress">
                    <div className="progressContent">
                        <div className="gameName">Gaming<br/>Arcade</div>
                        <div className="progressPercent">{percent}%</div>
                        <p className="loadingText">Laoding...</p>
                    </div>
                </CircularProgressbarWithChildren>
            </div>
            <p className="loadingText">In case the game does not loads up, please go to history tab and play again.</p>
        </div>
    </div>
  )
}

export default LoadingScreen;